module.exports = __webpack_public_path__ + "img/img_user_default.371a0302.svg";